import React from 'react';
import { connect } from 'react-redux';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { CompositeSessionInfoSelectors, SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { extractMoveToTheWebEnabled } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { SpaceHeaderTestIds } from '~src/spacesPlatform/components/header/SpaceHeader';
import { SpaceHeaderStyles } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';
import { FlowContentType, WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { IDataSourceDetailInfo } from '../../../../datasource/models/IDataSourceInfo';
import { IDatasourceActions } from '../../../../datasource/ServerApi/types/IDatasourceActions';
import { FlowAllowedActions } from '../../../../flow/serverApi/types/FlowAllowedActions';
import { IWorkbookActions } from '../../../../workbook/ServerApi/types/IWorkbookActions';
import { ConnectedEncryptionStatusDropdown } from './EncryptionStatusDropdown';

export function ExtractMetadata(props: ExtractMetadataProps): JSX.Element {
  const { itemInfo, availableActions, isEncryptionEnabled, isWebExtractionEnabled } = props;

  const isExtractMoveToTheWebEnabled = itemInfo.contentType === WorkbookContentType.name ? isWebExtractionEnabled :
  extractMoveToTheWebEnabled(isWebExtractionEnabled, [itemInfo  as IDataSourceDetailInfo]);

  const showExtractMetadata = !isExtractMoveToTheWebEnabled || itemInfo.contentType === FlowContentType.name;
  const lastRefreshedDate = itemInfo.lastRefreshedAt;
  const showExtractInfo = itemInfo.hasExtracts && lastRefreshedDate;
  let showEncryptionStatus = isEncryptionEnabled && itemInfo.hasEncryptableExtracts;
  if (showEncryptionStatus && itemInfo.contentType === FlowContentType.name && !FeatureFlags.maestroEarEnabled) {
    showEncryptionStatus = false;
  }

  // Disable business logic is taken care by the backend. One of the following conditions must be true to disable the dropdown actions
  // 1) User does not have permissions, Or
  // 2) Site Encryption is in Enforced/Disabled mode
  const disableEncryptionActions: boolean = availableActions.decryptExtracts === false && availableActions.encryptExtracts === false;

  return (
    <React.Fragment>
      { showExtractMetadata && showEncryptionStatus &&
        <ConnectedEncryptionStatusDropdown itemInfo={itemInfo} disabled={disableEncryptionActions} />}
      { showExtractMetadata && showExtractInfo &&
        <React.Fragment>
          {!showEncryptionStatus &&
            <span className={SpaceHeaderStyles.TextOnlyMetadataLabelWithLeftMargin}>
              {Messages.datasourceHeaderLastRefreshed()}
            </span>}
          <span className={SpaceHeaderStyles.MetadataInfo} data-tb-test-id={SpaceHeaderTestIds.lastRefreshed} title={Messages.datasourceHeaderLastRefreshed()}>
            {L10n.localizedDateTime(lastRefreshedDate)}
          </span>
        </React.Fragment>}
    </React.Fragment>
  );
}

export interface ExtractMetadataOwnProps {
  itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource' | 'flow'>;
  availableActions: IWorkbookActions | IDatasourceActions | FlowAllowedActions;
}

export interface ExtractMetadataStateProps {
  isEncryptionEnabled: boolean;
  isWebExtractionEnabled: boolean;
}

export type ExtractMetadataProps = ExtractMetadataOwnProps & ExtractMetadataStateProps;

const mapStateToProps: MapStateToProps<ExtractMetadataStateProps> = (state: AppState) => {
  return {
    isEncryptionEnabled: SessionServerSelectors.extractEncryptionEnabledOmniSwitch(state),
    isWebExtractionEnabled: CompositeSessionInfoSelectors.isWebExtractionEnabled(state)
  };
};

export const ConnectedExtractMetadata = connect(mapStateToProps)(ExtractMetadata);
